<ion-app>
  <ion-router-outlet [animated]="false" />
</ion-app>

<ion-alert
  [isOpen]="alertIsOpen()"
  (didDismiss)="customCloseAlert()"
  [header]="alertHeader()"
  [subHeader]="alertSubHeader()"
  [message]="alertMessage()"
  [buttons]="alertButtons()"
  [inputs]="alertInputs()" />
